import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const title = css`
  font-weight: 700;
  font-size: 18px;
  color: ${theme.colors.peoople['gris-oscuro']};
`;
